import { get } from 'svelte/store';
import { _ } from 'svelte-i18n';
export class Fetcher {
    constructor(backendUrl, popups, tokenSessionStorageRepository) {
        this.backendUrl = backendUrl;
        this.popups = popups;
        this.tokenSessionStorageRepository = tokenSessionStorageRepository;
        this.unauthorizedExceptionListeners = [];
    }
    async fetchGetJson(path, headers) {
        const fetchUrl = `${this.backendUrl}${path}`;
        const fetchHeaders = this.enhanceHeaders(headers);
        return await this.fetchJson(() => fetch(fetchUrl, {
            method: 'get',
            headers: fetchHeaders
        }));
    }
    async fetchPostJson(path, body, headers, disableUnauthorizedListeners = false) {
        const fetchUrl = `${this.backendUrl}${path}`;
        const fetchHeaders = this.enhanceHeaders(headers);
        const fetchBody = typeof body === 'string' ? body : JSON.stringify(body);
        return await this.fetchJson(() => fetch(fetchUrl, {
            method: 'post',
            headers: fetchHeaders,
            body: fetchBody
        }), disableUnauthorizedListeners);
    }
    beaconPostJson(path, body) {
        const fetchUrl = `${this.backendUrl}${path}`;
        const fetchBody = typeof body === 'string' ? body : JSON.stringify(body);
        navigator.sendBeacon(fetchUrl, fetchBody);
    }
    async fetchPutJson(path, body, headers) {
        const fetchUrl = `${this.backendUrl}${path}`;
        const fetchHeaders = this.enhanceHeaders(headers);
        const fetchBody = typeof body === 'string' ? body : JSON.stringify(body);
        return await this.fetchJson(() => fetch(fetchUrl, {
            method: 'put',
            headers: fetchHeaders,
            body: fetchBody
        }));
    }
    async fetchDeleteJson(path, headers) {
        const fetchUrl = `${this.backendUrl}${path}`;
        const fetchHeaders = this.enhanceHeaders(headers);
        return await this.fetchJson(() => fetch(fetchUrl, {
            method: 'delete',
            headers: fetchHeaders
        }));
    }
    async fetchJson(fetchFunction, disableUnauthorizedListeners = false) {
        let response;
        try {
            response = await fetchFunction();
        }
        catch (e) {
            return await this.handleFailedFetch(e);
        }
        if (!response.ok) {
            return await this.handleFailedResponse(response, disableUnauthorizedListeners);
        }
        return await response.json();
    }
    async handleFailedFetch(e) {
        await this.popups.addError(`${get(_)('commons.error.ServerCommunicationError')}: ${e}`);
        throw e;
    }
    async handleFailedResponse(response, disableUnauthorizedListeners = false) {
        const body = await response.text();
        let popupMessage = body;
        let exceptionMessage = body;
        try {
            const json = JSON.parse(body);
            popupMessage = json.message;
            exceptionMessage = json.error + ': ' + json.message;
        }
        catch (e) {
            // ignore
        }
        await this.popups.addError(`${get(_)('commons.error.Error')}: ${popupMessage}`);
        if (!disableUnauthorizedListeners && (response.status == 401 || response.status == 403)) {
            for (let listener of this.unauthorizedExceptionListeners) {
                await listener();
            }
        }
        throw new Error(`Erroneous call on backend: ${exceptionMessage || '[empty body]'} (${response.status})`);
    }
    enhanceHeaders(headers = {}) {
        let result = {
            'Content-Type': 'application/json'
        };
        const token = this.tokenSessionStorageRepository.getToken();
        if (token) {
            result = Object.assign(result, { 'Authorization': `bearer ${token}` });
        }
        result = Object.assign(result, headers);
        return result;
    }
    addUnauthorizedExceptionListener(listener) {
        this.unauthorizedExceptionListeners = [...this.unauthorizedExceptionListeners, listener];
    }
}
